"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProjectMemberDataGetter = exports.getProjectMemberCompanyDataGetter = exports.getMultipleProjectMembersDataGetter = exports.getDataGetterForRootCause = exports.getDataGetterForIssueTypeCategory = exports.getDataGetterForIssueType = exports.getCustomFieldDataGetter = void 0;
var _get = _interopRequireDefault(require("lodash/get"));
var _sdk = require("../../../../sdk");
var _oxygenUtils = require("../../../utils/data/oxygenUtils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 *
 * Get the data getter function used by a column to render an issue type uid as the type's title.
 *
 * @param {object} issueTypeEntitiesMap - the map of issue type uids to data describing the issue type
 *
 * @returns {Function} - the dataGetter function suitable for use as a column prop
 */
const getDataGetterForIssueType = _ref => {
  let {
    issueTypeEntitiesMap
  } = _ref;
  return _ref2 => {
    let {
      rowData,
      column
    } = _ref2;
    return (0, _get.default)(issueTypeEntitiesMap, rowData[column.dataKey], "-");
  };
};

/*
 * Get the data getter function used by a column to render an issue type uid as the type's title.
 *
 * @param {object} issueTypeEntitiesMap - the map of issue type uids to data describing the issue type
 *
 * @returns {Function} - the dataGetter function suitable for use as a column prop
 */
exports.getDataGetterForIssueType = getDataGetterForIssueType;
const getDataGetterForIssueTypeCategory = _ref3 => {
  let {
    issueTypeEntitiesMap
  } = _ref3;
  return _ref4 => {
    let {
      rowData,
      column
    } = _ref4;
    return (0, _get.default)(issueTypeEntitiesMap, [rowData[column.dataKey], "title"], "-");
  };
};

/**
 *
 * Get the data getter function used by a column to render an issue type uid as the type's title.
 *
 * @param {object} issueRootCauseEntitiesMap - the map of root cause uids to data describing the root cause
 *
 * @returns {Function} - the dataGetter function suitable for use as a column prop
 */
exports.getDataGetterForIssueTypeCategory = getDataGetterForIssueTypeCategory;
const getDataGetterForRootCause = _ref5 => {
  let {
    issueRootCauseEntitiesMap
  } = _ref5;
  return _ref6 => {
    let {
      rowData,
      column
    } = _ref6;
    return (0, _get.default)(issueRootCauseEntitiesMap, [rowData[column.dataKey], "title"], "-");
  };
};

/** At the time of writing this comment, we only use this to display watchers which can only be users. If this function is used to display
 *  more than one type of project member, we may want to show some text to differentiate between users/roles/companies
 */
exports.getDataGetterForRootCause = getDataGetterForRootCause;
const getMultipleProjectMembersDataGetter = _ref7 => {
  let {
    usersEntitiesMap,
    rolesEntitiesMap,
    companiesEntitiesMap,
    companyIdToUserNameCountMap,
    T
  } = _ref7;
  return _ref8 => {
    let {
      rowData,
      column
    } = _ref8;
    const oxygenIds = rowData[column.dataKey];
    return oxygenIds !== null && oxygenIds !== void 0 && oxygenIds.length ? oxygenIds.map(id => (0, _oxygenUtils.getProjectMemberDisplayName)({
      usersEntitiesMap,
      rolesEntitiesMap,
      companiesEntitiesMap,
      companyIdToUserNameCountMap,
      id,
      T
    })).join(", ") : " - ";
  };
};
exports.getMultipleProjectMembersDataGetter = getMultipleProjectMembersDataGetter;
const getProjectMemberDataGetter = _ref9 => {
  let {
    usersEntitiesMap,
    rolesEntitiesMap,
    companiesEntitiesMap,
    companyIdToUserNameCountMap,
    T
  } = _ref9;
  return _ref10 => {
    let {
      rowData,
      column
    } = _ref10;
    const id = rowData[column.dataKey];
    const result = (0, _oxygenUtils.getProjectMemberDisplayName)({
      usersEntitiesMap,
      rolesEntitiesMap,
      companiesEntitiesMap,
      companyIdToUserNameCountMap,
      id,
      T
    });
    if (result) {
      return result;
    }
    // if there is not result, but an id exists, its a former member
    if (id) {
      return T.translate("removedMember");
    }
    return " - ";
  };
};
exports.getProjectMemberDataGetter = getProjectMemberDataGetter;
const getProjectMemberCompanyDataGetter = _ref11 => {
  let {
    usersEntitiesMap,
    companiesEntitiesMap
  } = _ref11;
  return _ref12 => {
    let {
      rowData,
      column
    } = _ref12;
    const id = rowData[column.dataKey];
    const assignedToType = rowData.assignedToType;
    return (0, _oxygenUtils.getProjectMemberCompanyDisplayName)({
      usersEntitiesMap,
      companiesEntitiesMap,
      assignedToType,
      id
    }) || " - ";
  };
};
exports.getProjectMemberCompanyDataGetter = getProjectMemberCompanyDataGetter;
const getCustomFieldDataGetter = _ref13 => {
  let {
    customFieldEntitiesMap,
    helperFunctions
  } = _ref13;
  return _ref14 => {
    let {
      rowData,
      column
    } = _ref14;
    // get the issue's custom attributes that match the table column
    const customAttribute = rowData.customAttributes.find(attr => attr.attributeDefinitionId === column.key);
    if (customAttribute) {
      if ((customAttribute === null || customAttribute === void 0 ? void 0 : customAttribute.type) === _sdk.IssueCustomAttributeType.Numeric && helperFunctions) {
        return helperFunctions.formatLocalizedNumber(customAttribute.value);
      }
      if (customAttribute.type !== _sdk.IssueCustomAttributeType.List) {
        return customAttribute.value || "-";
      } else {
        const options = (0, _get.default)(customFieldEntitiesMap, [column.key, "metadata", "list", "options"]);
        const option = options.find(option => option.id === customAttribute.value);
        return option ? option.value : "-";
      }
    }
  };
};
exports.getCustomFieldDataGetter = getCustomFieldDataGetter;
//# sourceMappingURL=dataGetters.js.map